import { application } from "./application"

import CellStateController from "./cell_state_controller"
import CommentFormController from "./comment_form_controller"
import ModalController from "./modal_controller"
import DrawerController from "./drawer_controller"
import IssueFormController from "./issue_form_controller"
import DateRangeController from "./date_range_controller"
import TaskReorderController from "./task_reorder_controller"
import ThemeController from "./theme_controller"
import FlashController from "./flash_controller"
import NestedFormController from "./nested_form_controller"
import Select2Controller from "./select2_controller"
import SidebarController from "./sidebar_controller"
import DropDownController from "./dropdown_controller"
import CellToggleController from "./cell_toggle_controller"
import MobileTimelineController from "./mobile_timeline_controller"
import SharedMenuController from "./shared_menu_controller"
import SharedCategoryMenuController from "./shared_category_menu_controller"
import ChecklistItemController from "./checklist_item_controller"
import BugReportFormController from "./bug_report_form_controller"
import IssueFilterController from "./issue_filter_controller"
import CategoryAccordionController from "./category_accordion_controller"
import StatusReorderController from "./status_reorder_controller"
import StatusSelectController from "./status_select_controller"
import PrioritySelectController from "./priority_select_controller"
import PopupMenuController from "./popup_menu_controller"
import SearchController from "./search_controller"
import UserFormController from "./user_form_controller"
import ClipboardController from "./clipboard_controller"
import RedirectController from "./redirect_controller"
import PushNotificationsController from "./push_notifications_controller"

import DynamicInputsController from "./dynamic_inputs_controller"
import ProjectCodeController from "./project_code_controller"
import CategoryDatesController from "./category_dates_controller"
import ColumnResizeController from "./column_resize_controller"
import DisableSubmitController from "./disable_submit_controller"

application.register("cell-state", CellStateController)
application.register("comment-form", CommentFormController)
application.register("modal", ModalController)
application.register("drawer", DrawerController)
application.register("issue-form", IssueFormController)
application.register("date-range", DateRangeController)
application.register("task-reorder", TaskReorderController)
application.register("theme", ThemeController)
application.register("flash", FlashController)
application.register("nested-form", NestedFormController)
application.register("select2", Select2Controller)
application.register("sidebar", SidebarController)
application.register("dropdown", DropDownController)
application.register("cell-toggle", CellToggleController)
application.register("mobile-timeline", MobileTimelineController)
application.register("shared-menu", SharedMenuController)
application.register("shared-category-menu", SharedCategoryMenuController)
application.register("checklist-item", ChecklistItemController)
application.register("bug-report-form", BugReportFormController)
application.register("issue-filter", IssueFilterController)
application.register("category-accordion", CategoryAccordionController)
application.register("status-reorder", StatusReorderController)
application.register("status-select", StatusSelectController)
application.register("priority-select", PrioritySelectController)
application.register("popup-menu", PopupMenuController)
application.register("search", SearchController)
application.register("user-form", UserFormController)
application.register("clipboard", ClipboardController)
application.register("redirect", RedirectController)
application.register("project-code", ProjectCodeController)
application.register("push-notifications", PushNotificationsController)

application.register("dynamic-inputs", DynamicInputsController)
application.register("category-dates", CategoryDatesController)
application.register("column-resize", ColumnResizeController)
application.register("disable-submit", DisableSubmitController)
